export default function () {

}


// WEBPACK FOOTER //
// ./themes/app/src/js/gallery-popup.js